import React from 'react'
import Weather from './Components/Weather'

const App = () => {
  return (
    <div className='app'>
      <Weather/>

    </div>
  )
}

export default App